import { useState } from 'react';

import {
  Container,
  ReservationLogsFilters,
  ReservationLogsTable,
  Show,
} from '../../components';
import { usePageTitle } from '../../hooks';
import { UserPermission } from '../../enums';
import { getPageTitle } from '../../utils/pages';
import { RequirePermission } from '../../security';
import { Nullable, ReservationLogsFilters as Filters } from '../../types';
import Reports from './partials/Reports';

const ReservationLogs = () => {
  usePageTitle(getPageTitle('reports.reservationActivity'));
  const [filters, setFilters] = useState<Nullable<Filters>>(null);

  const handleSearch = (filters: Nullable<Filters>) => {
    setFilters(filters);
  };

  return (
    <RequirePermission oneOf={[UserPermission.ViewLogs]}>
      <Reports>
        <ReservationLogsFilters onSearch={handleSearch} />

        <Container>
          <Show if={!!filters}>
            <ReservationLogsTable filters={filters} />
          </Show>
        </Container>
      </Reports>
    </RequirePermission>
  );
};

export default ReservationLogs;
